export enum RecurringEventUpdateType {
    Single = 'SINGLE',
    All = 'ALL',
    Future = 'FUTURE',
}
